import { useMutation, UseMutationResult } from 'react-query';

import { ApiErrorItem } from 'src/types/ApiErrorType';

import { onbordingStatusUpdate } from 'src/utils/urls';

type TResult<TData = unknown> = {
  Errors: ApiErrorItem[];
  ErrorId: string;
  IsSuccess: boolean;
  StatusCode: number;
  Data?: TData;
};

type TError = Error;

type TVariable = {
  id: string | null;
  status: number;
};

async function updateOnboardingStatus({
  id,
  status,
}: TVariable): Promise<TResult> {
  const response = await fetch(onbordingStatusUpdate(id), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      tenant: process.env.REACT_APP_TENANT_ID || '',
    },
    body: JSON.stringify({ Status: status }),
  });

  let data: TResult | null = null;

  try {
    const text = await response.text();
    data = text ? JSON.parse(text) : null;
  } catch (e) {
    console.error('JSON parse failed:', e);
  }

  if (!data) {
    throw new Error('Invalid server response');
  }

  return data;
}

function useUpdateOnboardingStatus(): UseMutationResult<
  TResult,
  TError,
  TVariable,
  unknown
> {
  return useMutation(async ({ id, status }: TVariable) => {
    const result = await updateOnboardingStatus({ id, status });

    if (!result.IsSuccess) {
      const errorMessage =
        result.Errors?.map(err => err.Message).join(', ') ||
        'Failed to update onboarding status. Please try again.';

      throw new Error(errorMessage);
    }

    return result;
  });
}

export { useUpdateOnboardingStatus };
